import React from 'react';
import { motion } from 'framer-motion';
import StarRating from './StarRating';

const LOGO = "https://static.prod-images.emergentagent.com/jobs/6554b71a-e92e-45d6-a2ea-28b8d837c5dd/images/05ed22a83a162dbd4a68bdfa54453a7a8a9f16d8e3a633061831e14ecf8e4761.jpeg";

const ReviewCard = ({ review, index = 0 }) => {
  const initials = review.customer_name
    ? review.customer_name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : '??';

  const date = review.created_at
    ? new Date(review.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';

  const replyDate = review.replied_at
    ? new Date(review.replied_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';

  return (
    <motion.div
      data-testid={`review-card-${review.id}`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.06, duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="bg-white border border-gray-100 rounded-2xl p-6"
      style={{ boxShadow: '0 1px 4px rgba(10,22,40,0.04)' }}
    >
      {/* Reviewer header */}
      <div className="flex items-start justify-between gap-4 mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-navy rounded-full flex items-center justify-center text-white text-sm font-semibold shrink-0">
            {initials}
          </div>
          <div>
            <p className="font-semibold text-navy text-sm">{review.customer_name}</p>
            <p className="text-gray-400 text-xs">{date}</p>
          </div>
        </div>
        <StarRating value={review.rating} readOnly size="sm" />
      </div>

      {/* Review content */}
      {review.title && (
        <p className="font-semibold text-navy text-sm mb-1.5">{review.title}</p>
      )}
      <p className="text-gray-500 text-sm leading-relaxed">{review.comment}</p>

      {/* Owner reply */}
      {review.reply && (
        <div
          data-testid={`review-reply-${review.id}`}
          className="mt-4 bg-[#FAFAF9] border border-gray-100 rounded-xl p-4"
        >
          <div className="flex items-center gap-2 mb-2">
            <div className="w-6 h-6 rounded-full overflow-hidden bg-navy flex items-center justify-center shrink-0">
              <img src={LOGO} alt="HYGAD" className="w-5 h-5 object-contain" />
            </div>
            <span className="text-xs font-semibold text-navy">Response from owner</span>
            {replyDate && (
              <span className="text-gray-400 text-xs">· {replyDate}</span>
            )}
          </div>
          <p className="text-gray-600 text-sm leading-relaxed">{review.reply}</p>
        </div>
      )}
    </motion.div>
  );
};

export default ReviewCard;
